/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-07-07 10:59:18
 * @FilePath: /vue_huaqiang/src/api/factory-packing-list.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";
import requestOMS from "@/utils/oms-request";
import download from "@/utils/download";


export const uploadFactoryPackingList = (data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/factory-packing-list",
    method: "post",
    data: data
  });
export const uploadByOms = (params: any) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/hq-packing-lists/upload-by-oms",
    method: "post",
    params
  });


export const exportHqPackingList = (data) =>
  request({
    url: "/factory-packing-list/hq-packing-lists",
    method: "post",
    data: data
  });
export const parentCode = (params: any) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/hq-packing-lists/parent-code",
    method: "get",
    params
  });
export const moneyType = () =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/hq-packing-lists/money",
    method: "get"
  });
export const getAdditionalCosts = (id: any,) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: `/hq-packing-lists/${id}/additional-costs`,
    method: "get",
  });
export const additionalCosts = (id: any, data: any) =>
  request({
    url: `/hq-packing-lists/${id}/additional-costs`,
    method: "put",
    data
  });

export const issuance = (data: any) =>
  requestOMS({
    url: `/abnormal-delivery/purchase-order-infos/issuance`,
    method: "put",
    data
  });
// 保存到装箱单
export const saveToPackingList = (id: any, data: any) =>
  request({
    url: `/hq-packing-lists/${id}/created`,
    method: "put",
    data
  });
